
import React from 'react';

type CustomTooltipProps = {
  active?: boolean;
  payload?: any[];
  label?: string;
};

const CustomTooltip = ({ active, payload, label }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-secondary/90 p-3 border border-primary/20 rounded shadow-md w-[150px]">
        <p className="text-white font-medium mb-1 text-[11px]">{label}</p>
        {payload.map((entry: any, index: number) => (
          <p key={`item-${index}`} className="text-white text-[11px]">
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default CustomTooltip;
